<template>
 <div class="footer-wrapper">
   <div class="copyRight">
     <p>COPYRIGHT © 2018 D-63  ALL RIGHTSRESERVED POWER BY:<a :href="yf" target="_blank">YUFEI DESIGN</a>  <a href="https://beian.miit.gov.cn" style="margin-left: 8px" target="_blank">粤ICP备16064170号</a></p>
   </div>
   <div class="icon">
     <a :href="wb"  target="_blank">
       <i class="icon-font icon-weibo" ></i>
       <span class="icon-tips">新浪微</span>
     </a>
     <a href="#">
       <img :src="logo" alt="">
       <span class="mall"></span>
       <span class="malltitle">扫一扫搜索官方商城</span>
     </a>
     <a href="#">
       <i class="icon-font icon-wechat"></i>
       <span class="wx"></span>
       <span class="wxtitle">扫一扫搜索公众号</span>
     </a>
   </div>
 </div>
</template>

<script>
  export default {
    name: 'v-footer',
    data() {
      return {
        logo: '/static/img/mallw.png',
        yf: "http://www.yfd.com.cn/",
        wb: " https://weibo.com/u/6456964273"
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "~common/scss/mixin";
  .footer-wrapper{
    height: 84px;
    padding: 0 60px;
    color: #333;
    font-size: 12px;
    display: table;
    width: 100%;
    font-family: Arial;
    /*background: url("../assets/db.jpg") repeat;*/
    /*background-size: contain;*/
    background-color: #325314;
    @media (max-width: 980px){
      padding: 0 20px;
    }
    @media (max-width: 768px){
      height: 60px;
      font-size: 10px;
      line-height: 16px;
      text-align: center;
      padding: 0 10px;
    }
    .copyRight{
      display: table-cell;
      width: 80%;
      text-align: left;
      vertical-align: middle;
      color: #fff;
      opacity: 0.7;
      @media (max-width: 768px){
        float: none;
        text-align: center;
      }
      a{
        color: #fff;
        &:hover{
          color: #0cc;;
        }
        @media (max-width: 640px){
          display: block;
        }
      }
    }
    .icon{
      width: 20%;
      display: table-cell;
      text-align: right;
      line-height: 100px;
      opacity: 1;
      @media (max-width: 768px){
        display: none;
      }
      a{
        color: #333333;
        margin-right: 20px;
        transition: all 0.3s;
        position: relative;
        i{
          opacity: 0.7;
        }
        img{
          width: 20px;
          height: 20px;
          opacity: 0.7;
          margin-bottom: 5px;
        }
        &:last-child{
          margin-right: 0;
        }
        &:hover{
          opacity: 1;
          .icon-tips{
            opacity: 1;
          }
          .wx{
            transform: scale(1);
            opacity: 1;
            &:after{
              opacity: 1;

            }
          }
          .mall{
            transform: scale(1);
            opacity: 1;
            &:after{
              opacity: 1;

            }
          }
          .malltitle{
            transform: scale(1);
            opacity: 0.7;
            &:after{
              opacity: 0.7;

            }
          }
          .wxtitle{
            transform: scale(1);
            opacity: 0.7;
            &:after{
              opacity: 0.7;

            }
          }
        }
      }
      .icon-tips{
        position: absolute;
        top: -30px;
        left: 8px;
        height: 18px;
        padding: 0 5px;
        border: 1px solid #fff;
        border-radius: 4px;
        font-size: 10px;
        color: #fff;
        line-height: 16px;
        white-space: nowrap;
        opacity: 0;
        transform: translate(-50%, 0);
        transition: all .35s;
        backface-visibility: hidden;
        &:before{
          content: "";
          position: absolute;
          left: 50%;
          display: block;
          width: 0;
          height: 0;
          margin-left: -6px;
          opacity: 0.6;
          border-top: 6px solid #fff;
          border-right: 6px solid transparent;
          border-left: 6px solid transparent;
        }
        &:before{
          bottom: -7px;
        }
      }
      .wx{
        position: absolute;
        top: -125px;
        right: -31px;
        width: 84px;
        height: 84px;
        background: #fff url(../assets/wx.jpg) no-repeat;
        background-size: cover;
        transform: scale(0);
        transition: all 0.3s;
        z-index: 99999;
        &:after{
          content: "";
          position: absolute;
          left: 50%;
          bottom: -5%;
          display: block;
          width: 0;
          height: 0;
          margin-left: -6px;
          border-top: 6px solid #fff;
          border-right: 6px solid transparent;
          border-left: 6px solid transparent;
          opacity: 1;
        }
      }
      .wxtitle{
             position: absolute;
             top: -70px;
             right: -37px;
             width: 110px;
             height: 84px;
             color: #fff;

             background-size: cover;
             transform: scale(0);
             transition: all 0.3s;
             z-index: 99999;

           }

      .mall{
        position: absolute;
        top: -125px;
        right: -31px;
        border-radius: 50%;
        width: 84px;
        height: 84px;
        background: #fff url(../assets/MallQR_code.png) no-repeat;
        background-size: cover;
        transform: scale(0);
        transition: all 0.3s;
        z-index: 99999;
        &:after{
          content: "";
          position: absolute;
          left: 50%;
          bottom: -5%;
          display: block;
          width: 0;
          height: 0;
          margin-left: -6px;
          border-top: 6px solid #fff;
          border-right: 6px solid transparent;
          border-left: 6px solid transparent;
          opacity: 1;
        }
      }
      .malltitle{
        position: absolute;
        top: -70px;
        right: -42px;
        width: 110px;
        height: 84px;
        color: #fff;

        background-size: cover;
        transform: scale(0);
        transition: all 0.3s;
        z-index: 99999;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VFooter.vue